import { createContext, useContext, useState } from 'react';

const AIChatContext = createContext(null);

export function AIChatProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <AIChatContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </AIChatContext.Provider>
  );
}

export function useAIChat() {
  return useContext(AIChatContext);
}
